import Attachment from '@berlitz/streamline-icons/lib/regular/01-Interface-Essential/27-Link-Unlink/Attachment'
import Notes from '@berlitz/streamline-icons/lib/regular/11-Content/01-Content-Creation/ContentPaperEdit'
import React from 'react'
import { ActionWrapper } from './style'

interface ICardAction {
  hasAttachment: boolean
  hasNote: boolean
  noteAction: () => void
  attachmentAction: () => void
  pastDate?: boolean
  status: string
}

const CardActions: React.FC<ICardAction> = ({
  hasAttachment,
  hasNote,
  noteAction,
  attachmentAction,
  pastDate,
  status,
}) => {
  const isCancelled = status.toLowerCase() === 'cancelled'
  return (
    <ActionWrapper>
      {(hasAttachment || (!pastDate && !isCancelled)) && (
        <a onClick={attachmentAction}>
          <Attachment color={`${hasAttachment ? 'brand06' : 'brand07'}`} className={'files'} />
        </a>
      )}
      {(hasNote || (!pastDate && !isCancelled)) && (
        <a onClick={noteAction}>
          <Notes color={`${hasNote ? 'brand06' : 'brand07'}`} className={`files`} />
        </a>
      )}
    </ActionWrapper>
  )
}

export default CardActions
